import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'
import {Link, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {categoryUrlBuilder} from '../../../../utils/url'

export const PromoQuickCategoryLink = ({
    linkLabel,
    linkLabelTag,
    linkUrl,
    linkFontFamily,
    linkFontColor,
    titleText = null
}) => {
    linkFontColor = linkFontColor ? linkFontColor : 'black.100'

    if (!linkUrl) {
        return null
    }

    return (
        <Link
            to={categoryUrlBuilder({c_alternativeUrl: linkUrl})}
            as={RouteLink}
            _hover={{textDecoration: 'none', color: linkFontColor}}
            _active={{color: linkFontColor}}
            textUnderlineOffset="6px"
            flexShrink="0"
            width="auto"
            textDecoration="underline"
            color={linkFontColor}
            fontFamily={linkFontFamily}
        >
            {linkLabel && (
                <Text
                    as={linkLabelTag}
                    fontSize="20px"
                    fontWeight={titleText ? '700' : '400'}
                    letterSpacing="0.1px"
                >
                    {linkLabel}
                </Text>
            )}
        </Link>
    )
}

PromoQuickCategoryLink.propTypes = {
    titleText: PropTypes.string,
    linkLabel: PropTypes.string,
    linkLabelTag: PropTypes.string,
    linkUrl: PropTypes.string,
    linkFontFamily: PropTypes.string,
    linkFontColor: PropTypes.string
}

export default PromoQuickCategoryLink
